/* Just Brilliant: preserve an unsaved order note when the request fails. */
if (!customElements.get('cart-notes')) customElements.define('cart-notes', class extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.toggle = this.querySelector('.order-note-toggle');
    this.content = this.querySelector('.order-note-toggle__content');
    this.notes = this.querySelector('textarea');
    if (!this.toggle || !this.content || !this.notes) return;
    this.toggle.addEventListener('click', () => { this.content.classList.add('active'); this.toggle.setAttribute('aria-expanded', 'true'); this.notes.focus({ preventScroll: true }); }, { signal });
    this.content.addEventListener('click', async event => {
      if (!event.target.closest('.button, .order-note-toggle__content-overlay') || this.pending) return;
      event.preventDefault(); this.pending = true;
      try {
        if (await window.JBCart.saveNote(this, this.notes.value)) { this.content.classList.remove('active'); this.toggle.setAttribute('aria-expanded', 'false'); this.toggle.focus({ preventScroll: true }); }
      } finally { this.pending = false; }
    }, { signal });
  }
  disconnectedCallback() { this.controller?.abort(); this.controller = null; }
});
